// extracted by mini-css-extract-plugin
export default {"notFound":"VisitedItems_notFound__cvijQ"};